export const config = {
    apiUrl: import.meta.env.VITE_API_URL || '/api/v1',
    appName: import.meta.env.VITE_APP_NAME || 'Cosmetic Store',
    cloudinaryCloudName: import.meta.env.VITE_CLOUDINARY_CLOUD_NAME || '',
};

export const ROUTES = {
    // Client routes
    HOME: '/',
    PRODUCTS: '/products',
    PRODUCT_DETAIL: (slug: string) => `/products/${slug}`,
    CART: '/cart',
    CHECKOUT: '/checkout',
    LOGIN: '/login',
    REGISTER: '/register',
    PROFILE: '/profile',
    PROFILE_ORDERS: '/profile/orders',
    PROFILE_ADDRESSES: '/profile/addresses',
    PROFILE_PASSWORD: '/profile/password',
    ORDERS: '/orders',
    ORDER_DETAIL: (id: string) => `/orders/${id}`,
    ORDER_SUCCESS: (orderId: string) => `/order-success/${orderId}`,

    // Admin routes
    ADMIN: {
        DASHBOARD: '/admin',
        PRODUCTS: '/admin/products',
        PRODUCT_NEW: '/admin/products/new',
        PRODUCT_EDIT: (id: string) => `/admin/products/${id}/edit`,
        CATEGORIES: '/admin/categories',
        ORDERS: '/admin/orders',
        USERS: '/admin/users',
        COUPONS: '/admin/coupons',
        REVIEWS: '/admin/reviews',
        SETTINGS: '/admin/settings',
    },
};

export const QUERY_KEYS = {
    AUTH: {
        USER: ['auth', 'user'],
    },
    PRODUCTS: {
        ALL: ['products'],
        DETAIL: (slug: string) => ['products', slug],
        FEATURED: ['products', 'featured'],
        RELATED: (id: string) => ['products', id, 'related'],
        REVIEWS: ['products', 'reviews'],
    },
    CATEGORIES: {
        ALL: ['categories'],
    },
    CART: {
        ITEMS: ['cart'],
    },
    ORDERS: {
        ALL: ['orders'],
        DETAIL: (id: string) => ['orders', id],
    },
    ADMIN: {
        QUEUE: ['admin', 'queue'],
        ANALYTICS: ['admin', 'analytics'],
        SETTINGS: ['admin', 'settings'],
    },
};

export default config;
